import { useTranslation } from "react-i18next";

import { cap } from "../../../utils/utils";

function InputStatus({ type, name, value, onChange, options, error }) {
  const { t } = useTranslation();

  const optionFormatter = {
    "No Show": "noShow",
    Confirmed: "accepted",
  };

  return (
    <div className={`lineInput lineInput${type} lineInput${cap(name)} ${error ? "invalid" : ""}`}>
      <label htmlFor={name}>{t("STATUS")}</label>
      <div className="select-wrapper">
        <select name={name} value={value} onChange={(e) => onChange(e, name)}>
          <option value={""}> {t("SELECT")}</option>
          {options.map((option) => (
            <option key={option.name} value={optionFormatter[option.name] || option.name.toLowerCase()}>
              {" "}
              {option.name}{" "}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default InputStatus;
